var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5162 8.05828V20.6915C31.5162 21.9796 31.0234 23.2188 30.1388 24.1551C29.2542 25.0913 28.0449 25.6536 26.7589 25.7265L26.4734 25.7343H5.52663C4.23858 25.7343 2.99932 25.2415 2.06307 24.3569C1.12682 23.4723 0.564569 22.263 0.491645 20.977L0.483887 20.6915V8.05828L15.4601 15.9032C15.6267 15.9905 15.8119 16.0361 16 16.0361C16.1881 16.0361 16.3734 15.9905 16.54 15.9032L31.5162 8.05828ZM5.52663 0.908447H26.4734C27.7234 0.908297 28.9288 1.37237 29.856 2.21067C30.7832 3.04896 31.366 4.20172 31.4913 5.44536L16 13.5603L0.508713 5.44536C0.628999 4.25111 1.17133 3.13892 2.03822 2.30872C2.9051 1.47852 4.03969 0.984766 5.23803 0.916206L5.52663 0.908447H26.4734H5.52663Z",
    fill: "#FFFAE9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.73653b6998c0ebb6fa6cf692d560fe48.svg";
export { ForwardRef as ReactComponent };